import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Servicespartner(props) {
  return (
    <div className="tekrevol_gray_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Solutions">
              <h2>Revolutionize Your Online Business Structure</h2>
            </div>
            <h5 className="strong">
              Why Choose TekRevol for Infrastructure Migration Services?
            </h5>
            <p>
              With the integration of cutting-edge technologies into your
              business, TekRevol gives it a modern touch for extended reach and
              improved functioning. The goal is to ultimately help you serve
              your purpose and achieve your objectives better. While
              acknowledging your business needs and functionalities, we employ
              our expertise and knowledge to successfully deploy your
              infrastructure to the cloud for seamless business performance.
            </p>
            <p>
              Having extensive industry experience, we have developed a
              well-sorted reputation in the market, which comes in handy to
              satisfy our clients well. We ensure to always put our professional
              approach and skillful minds at work to give you the desired
              solutions.
            </p>
            <p>
              What makes us confident about our infrastructure migration
              services and professionalism is the concrete and result-driven
              solutions we provide you with. Having a set of extensive skills, a
              team of smart workers, and some great technical knowledge, we have
              a foolproof success formula.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <StaticImage
              src="../../images/services/infrastructure/why_choose.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={651}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Servicespartner;
